import { useState } from "react";
import { ShieldAlert, Check, X, Loader2, CheckCircle2, Ban } from "lucide-react";
import { toast } from "sonner";
import { http, emitRefresh, formatError } from "@/lib/api";

export const PendingCard = ({ item }) => {
  const [status, setStatus] = useState(item.status);
  const [busy, setBusy] = useState(false);
  const act = async (kind) => {
    setBusy(true);
    try {
      const { data } = await http.post(`/omvexis/pending/${item.id}/${kind}`);
      setStatus(data.status);
      if (data.status === "done") { toast.success(`Done: ${item.summary}`); emitRefresh(); }
      if (data.status === "failed") toast.error(data.result);
    } catch (e) { toast.error(formatError(e)); }
    setBusy(false);
  };
  return (
    <div className={`border rounded-2xl px-4 py-3 flex flex-wrap items-center gap-3 justify-between ${item.risky ? "border-amber-500/50 bg-amber-950/20" : "border-cyan-500/40 bg-cyan-950/20"}`} data-testid={`pending-card-${item.id}`}>
      <div className="min-w-0">
        <div className="flex items-center gap-2 text-sm text-slate-100">
          {item.risky && <ShieldAlert size={14} className="text-amber-300 shrink-0" />}
          <span>{item.summary}</span>
        </div>
        <div className="font-mono-hud text-[10px] text-slate-500 truncate">{item.method} {item.path}</div>
      </div>
      {status === "pending" ? (
        <div className="flex gap-2">
          <button className="hud-btn !py-1 !px-3" disabled={busy} onClick={() => act("confirm")} data-testid={`pending-confirm-${item.id}`}>{busy ? <Loader2 size={12} className="animate-spin" /> : <Check size={12} />} Confirm</button>
          <button className="hud-btn hud-btn-ghost !py-1 !px-3" disabled={busy} onClick={() => act("cancel")} data-testid={`pending-cancel-${item.id}`}><X size={12} /></button>
        </div>
      ) : (
        <span className={`font-mono-hud text-[10px] uppercase tracking-wider flex items-center gap-1 ${status === "done" ? "text-emerald-300" : "text-slate-400"}`} data-testid={`pending-status-${item.id}`}>
          {status === "done" ? <CheckCircle2 size={12} /> : <Ban size={12} />} {status}
        </span>
      )}
    </div>
  );
};

export const confirmAll = async (items) => {
  for (const it of items) await http.post(`/omvexis/pending/${it.id}/confirm`).catch(() => {});
  emitRefresh();
};
